<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10 12.2917V2.29175"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.5 12.2915V15.6248C17.5 16.0669 17.3244 16.4908 17.0118 16.8033C16.6993 17.1159 16.2754 17.2915 15.8333 17.2915H4.16667C3.72464 17.2915 3.30072 17.1159 2.98816 16.8033C2.67559 16.4908 2.5 16.0669 2.5 15.6248V12.2915"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.83333 8.125L10 12.2917L14.1667 8.125"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconDownload',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
